import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { GraphBatteryModbus } from './graphs/GraphBatteryModbus.js';
import FontAwesome from 'react-fontawesome';

export class BatteryGraph extends BaseComponent {
  constructor(props) {
    super(props);

    let battery = '';
    if (this.props.inputRegister) {
      battery = this.props.inputRegister;
    }
    this.state = {
      token: this.props.token,
      ieee: this.props.ieee,
      inputRegister: this.props.inputRegister,
      batteries: battery,
      online: this.props.online,
      open: true,
      overlayGraph: false,
    };

    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.showDetailGraph = this.showDetailGraph.bind(this);
    this.renderBatteryImage = this.renderBatteryImage.bind(this);
    this.renderOverlayGraph = this.renderOverlayGraph.bind(this);
  }

  componentWillReceiveProps(prop) {
    if (prop.inputRegister !== this.state.inputRegister) {
      this.setState({ inputRegister: prop.inputRegister });
    }
    if (prop.batteries !== this.state.batteries) {
      this.setState({ batteries: prop.batteries });
    }
    if (prop.online !== this.state.online) {
      this.setState({ online: prop.online });
    }
  }

  renderToggleClass() {
    if (this.state.open) {
      return 'single-device single-device--toggle single-device--open';
    }
    return 'single-device single-device--toggle';
  }

  toggleAccordion() {
    this.setState({ open : !this.state.open });
  }

  renderBatteryValue(name, unit) {
    if (this.state.batteries) {
      if (this.state.batteries.hasOwnProperty(name)) {
        return(
          <div>
            <span>Clicca per vedere il dettaglio</span>
            { this.state.batteries[name].toFixed(2) + unit }
          </div>
        );
      } else {
        return(
          <div>
            <span>Clicca per vedere il dettaglio</span>
            { ' --- ' }
          </div>
        );
      }
    }
    return '';
  }

  showDetailGraph(prop) {
    if (this.state.batteries && this.state.batteries.hasOwnProperty(prop)) {
      this.setState({ overlayGraph: prop });
    }
  }

  renderBatteryImage(perc) {
    if (this.state.batteries && this.state.batteries.hasOwnProperty(perc)) {
      perc = this.state.batteries[perc];
      let n = 0;

      if (perc > 12 && perc <= 25) {
        n = 1;
      } else if(perc > 25 && perc <= 38) {
        n = 2;
      } else if(perc > 38 && perc <= 51) {
        n = 3;
      } else if(perc > 51 && perc <= 64) {
        n = 4;
      } else if(perc > 64 && perc <= 77) {
        n = 5;
      } else if(perc > 77 && perc <= 90) {
        n = 6;
      } else if(perc > 90 && perc <= 99) {
        n = 7;
      } else if(perc > 99) {
        n = 8;
      }
      return(
        <img src={require('../images/battery/bat' + n + '.png')} alt="battery" className="battery-module__bat" />
      );
    }
    return(
      <img src={require('../images/battery/bat0.png')} alt="battery" className="battery-module__bat" />
    );
  }

  renderOverlayGraph() {
    if (this.state.overlayGraph !== false) {
      return(
        <div className="overlay">
          <div className="overlay__shadow" onClick={ () => { this.setState({ overlayGraph: false }); } }></div>
          <div className="overlay__content overlay__content--padded">
            <GraphBatteryModbus
              title={ this.state.overlayGraph }
              ieee={ this.state.ieee }
              token={ this.props.token }
              deviceID={ this.props.deviceID }
            />
          </div>
        </div>
      );
    }
    return '';
  }

  renderArrows1() {
    if (this.state.online) {
      if (this.state.batteries && this.state.batteries.hasOwnProperty('P_STOR')) {
        if (this.state.batteries['P_STOR'] > 0) {
          return(
            <img src={require('../images/battery/arrows-red.gif')} alt="arrows" className="battery-module__arrow battery-module__arrow-bat" />
          );
        } else if(this.state.batteries['P_STOR'] < 0) {
          return(
            <img src={require('../images/battery/arrows-green.gif')} alt="arrows" className="battery-module__arrow battery-module__arrow-bat battery-module__arrow battery-module__arrow-bat--reverse" />
          );
        } else {
          return(
            ''
          );
        }
      }
      return(
        <img src={require('../images/battery/arrows-grey.png')} alt="arrows" className="battery-module__arrow battery-module__arrow-bat" />
      );
    } else {
      return(
        <img src={require('../images/battery/arrows-grey.png')} alt="arrows" className="battery-module__arrow battery-module__arrow-bat" />
      );
    }
  }

  renderArrows2() {
    if (this.state.online) {
      return(
        <img src={require('../images/battery/arrows-red.gif')} alt="arrows" className="battery-module__arrow battery-module__arrow-home" />
      );
    } else {
      return(
        <img src={require('../images/battery/arrows-grey.png')} alt="arrows" className="battery-module__arrow battery-module__arrow-home" />
      );
    }
  }

  renderArrows3() {
    if (this.state.online) {
      return(
        <img src={require('../images/battery/arrows-green.gif')} alt="arrows" className="battery-module__arrow battery-module__arrow-panel" />
      );
    } else {
      return(
        <img src={require('../images/battery/arrows-grey.png')} alt="arrows" className="battery-module__arrow battery-module__arrow-panel" />
      );
    }
  }

  renderArrows4() {
    if (this.state.online) {
      if (this.state.batteries && this.state.batteries.hasOwnProperty('P_GRID')) {
        if (this.state.batteries['P_GRID'] > 0) {
          return(
            <img src={require('../images/battery/arrows-red.gif')} alt="arrows" className="battery-module__arrow battery-module__arrow-trellis battery-module__arrow-trellis--reverse" />
          );
        } else if(this.state.batteries['P_GRID'] < 0) {
          return(
            <img src={require('../images/battery/arrows-green.gif')} alt="arrows" className="battery-module__arrow battery-module__arrow-trellis battery-module__arrow" />
          );
        } else {
          return(
            <img src={require('../images/battery/arrows-grey.png')} alt="arrows" className="battery-module__arrow battery-module__arrow-trellis" />
          );
        }
      }
      return(
        <img src={require('../images/battery/arrows-grey.png')} alt="arrows" className="battery-module__arrow battery-module__arrow-trellis" />
      );
    } else {
      return(
        <img src={require('../images/battery/arrows-grey.png')} alt="arrows" className="battery-module__arrow battery-module__arrow-trellis" />
      );
    }
  }

  render() {
    return(
      <div className={ this.renderToggleClass() }>
        <div onClick={ this.toggleAccordion } className="single-device__topbar">Batteria <FontAwesome name="caret-down" className="single-device__topbar__plus" /></div>
        <div className="single-device__content">
          <div className="single-device__content__data">
            <div className="battery-module">
              { this.renderBatteryImage('SOC_STOR') }
              <div className="battery-module__txt battery-module__txt-bat-1" onClick={ () => { this.showDetailGraph('T_STOR') } }>{ this.renderBatteryValue('T_STOR', '°C') }</div>
              <div className="battery-module__txt battery-module__txt-bat-2" onClick={ () => { this.showDetailGraph('SOC_STOR') } }>{ this.renderBatteryValue('SOC_STOR', '%') }</div>
              <div className="battery-module__txt battery-module__txt-bat-3" onClick={ () => { this.showDetailGraph('P_STOR') } }>{ this.renderBatteryValue('P_STOR', 'W') }</div>

              <img src={require('../images/battery/inverter.png')} alt="inverter" className="battery-module__inverter" />

              <img src={require('../images/battery/go-home.png')} alt="home" className="battery-module__home" />
              <div className="battery-module__txt battery-module__txt-home-1" onClick={ () => { this.showDetailGraph('P_USER') } }>{ this.renderBatteryValue('P_USER', 'W') }</div>

              <img src={require('../images/battery/pannello.png')} alt="panel" className="battery-module__panel" />
              <div className="battery-module__txt battery-module__txt-panel-1" onClick={ () => { this.showDetailGraph('P_PV') } }>{ this.renderBatteryValue('P_PV', 'W') }</div>

              <img src={require('../images/battery/traliccio.png')} alt="trellis" className="battery-module__trellis" />
              <div className="battery-module__txt battery-module__txt-trellis-1" onClick={ () => { this.showDetailGraph('P_GRID') } }>{ this.renderBatteryValue('P_GRID', 'W') }</div>

              { this.renderArrows1() }
              { this.renderArrows2() }
              { this.renderArrows3() }
              { this.renderArrows4() }

            </div>
          </div>
        </div>
        { this.renderOverlayGraph() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BatteryGraph.js